import get from 'lodash/get';
import moment from 'moment';
import { range } from '../../../utils/Arr';
import { resultConstants } from 'features/Big9History/historyHelper';

export const SK_TIME_FORMAT = 'YYYY-MM-DD hh:mm:ss';

export const timeToUTC = (timeStr) =>
    moment(timeStr, SK_TIME_FORMAT)
        .utc()
        .valueOf();

export const countShares = (pool) =>
    pool.shares.reduce(
        (totalShares, share) => totalShares + share.numberOfShares,
        0
    );

export const countUserShares = (pool, userId) =>
    pool.shares
        .filter((share) => share.userId === userId)
        .reduce((totalShares, share) => totalShares + share.numberOfShares, 0);

export const countTotalAmount = (pool) =>
    pool.shares.reduce(
        (totalShares, share) => totalShares + share.totalAmount,
        0
    );

export const hasAvailableShares = (pool) =>
    ['OPEN', 'CREATED'].includes(pool?.status) &&
    get(pool, ['poolSettings', 'sharesLimit'], 0) - countShares(pool) > 0;

export const convertSelectionsToBig9Format = (
    selections,
    withEventNames = false,
    withResults = false
) => {
    return Object.fromEntries(
        selections.map(({ nr, marks, info }) => {
            const results = withResults
                ? info.result
                      .split(',')
                      .map((res) => resultConstants[res])
                      .filter((res) => res)
                : [];
            return [
                nr,
                {
                    marks: marks.length
                        ? [
                              ...new Set(
                                  marks.map((mark) => mark.split('/')).flat()
                              ),
                          ]
                        : [],
                    eventName: withEventNames ? info?.eventName : undefined,
                    results,
                },
            ];
        })
    );
};

export const findWildcardEventNumber = (selections) => {
    const item = Object.entries(selections).find(([, { marks }]) =>
        marks.includes('*')
    );

    if (!item) {
        return false;
    }

    const [, value] = item;

    return value.nr;
};

export const getBig9SelectionsSplitArray = (outcomes = {}) => {
    return Object.keys(outcomes).reduce((acc, key) => {
        // [ ['1', '2', 'X'], ['O', 'U'], ['*'] ]
        let splitArray = [[], [], []];

        outcomes[key].marks.map((item) => {
            if (item !== '') {
                if (item === 'O' || item === 'U') {
                    splitArray[1].push(item);
                } else if (item !== '*') {
                    splitArray[0].push(item);
                } else {
                    splitArray[2].push(item);
                }
            }
        });
        return { ...acc, [key]: splitArray };
    }, {});
};

// BE format: 18-SEP-22 05.30.00 PM
export const getStartTime = (pool) =>
    moment(pool.coupons[0].selections[0].info.startTime, 'DD-MMM-YY', 'en')
        .locale('da')
        .format('dddd \\D. DD.MM.YY');

export const convertCouponToBig9Format = (coupon) => {
    return {
        outcomes: convertSelectionsToBig9Format(coupon.selections, true),
        combinationCount: coupon.combinationCount,
        combinationPrice: coupon.combinationPrice,
    };
};

export const prepareSelectionsForDiff = (selections) => {
    return range(9, true).map((eventNumber) =>
        selections[eventNumber].marks.sort()
    );
};

export const selectionsChanged = (originalSelections, selectionsUpdate) => {
    return (
        JSON.stringify(prepareSelectionsForDiff(originalSelections)) !==
        JSON.stringify(prepareSelectionsForDiff(selectionsUpdate))
    );
};

export const countDeadlineTime = (deadlineTime = 0, startTime = 0) =>
    startTime
        ? moment(startTime)
              .subtract(deadlineTime || 0, 'minutes')
              .format('X')
        : 0;

export const getOngoingEvent = (events) => {
    let ongoingEvent = [];
    events.some((item) => {
        if (item.status !== 'DECIDED') {
            ongoingEvent.push(item);
        }
    });
    if (ongoingEvent.length === 1) {
        return {
            name: ongoingEvent[0].name,
            startTime: ongoingEvent[0].kickoff,
        };
    } else {
        return {};
    }
};
